export type { I18NButtonProps } from "./I18NButton.interface";
export { I18NButton } from "./I18NButton";